const TheirMessage = ({lastMessage,message}) => {
    const isFirstMessageyUser = !lastMessage || lastMessage.sender.username!=message.sender.username;


    return ( 
    <div className="message-row">
        {isFirstMessageyUser && (
            <div 
                className="message-avtar"
                style={{backgroundImage: `url(${message?.sender?.avtar})`}}
            />
        )}
        {message?.attachments?.length>0
             ? (
                 <img 
                   src={message.attachments[0].file}
                   alt="message-attachment"
                   className="message-image"
                    style={{marginLeft: isFirstMessageyUser ? "4px" : "48px"}}
                 />
               ) : (
                <div className="message" style={{float: "left",backgroundColor:"#CABCDC",marginLeft: isFirstMessageyUser ? "4px" : "48px"}}>
                    {message.text}
                </div>
               )
        }
    </div>
    );
}
export default TheirMessage;